<template>
  <FirstPage />
  <WhatIDo />
  <tech-stack />
</template>

<script>
import FirstPage from './pages/FirstPage.vue'
import TechStack from './pages/TechStack.vue'
import WhatIDo from "./pages/WhatIDo.vue"

export default {
  name: 'App',
  components: {
    FirstPage,
    WhatIDo,
    TechStack
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Albert+Sans:ital,wght@0,200;0,400;0,600;1,200;1,400&family=Goldman&display=swap');

body {
  background-color: black;
  margin: 0;
  top: 0;
  left: 0;
  box-sizing: border-box;
}

#app {
  font-family: 'Albert Sans';
  color: white;
  font-size: 1.5rem;
}

a {
  color: gold;
  text-decoration-color: gold;
}

.page {
  width: 100%;
  min-height: 100vh;
  position: relative
}

h1, h2, h3, h4, h5, h6 {
  font-family: 'Goldman', fantasy;
}

h5, h6 {
  margin: 0
}

.m-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(300px, 1fr));
  gap: 2rem
}

.words {
  font-weight: lighter;
}

@media screen and (max-width: 1024px) {
  .m-grid {
    grid-template-columns: repeat(2, minmax(250px, 1fr));
  }
}

@media screen and (max-width: 428px) {
  .m-grid {
    grid-template-columns: 100%
  }
}

</style>
